export default "__VITE_ASSET__bb6b025c__"